import Braserrie31 from '../Ruko/Braseif  3.webp'
import Braserrie32 from '../Ruko/Braseif  3.webp'


const Braserrie3images =[
Braserrie31,Braserrie32
]

export default Braserrie3images;